import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material/Select';
import { MachineryTypeDto } from 'entities/catalog';
import { getUnitsSelectOptions } from 'entities/machinery/lib/getUnitsSelectOptions';
import { IMachineryForm } from 'features/machinery/ui/MachineryDialog/MachineryDialog';
import { Field, FieldProps, FormikProps } from 'formik';
import { Input, SelectSearch } from 'shared/ui';

import { UnitDto } from '../../../units';

type Props = {
  machineryTypesList?: Array<MachineryTypeDto>;
  allUnits: Array<UnitDto>;
};

export const MachineryForm: FC<Props> = ({ machineryTypesList, allUnits }) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Input
        select
        label="machineryType"
        name="machinery_type"
        defaultValue={-1}
        defaultMenuItems={{
          value: '-1',
          text: 'wayStatusNone',
        }}
        menuItems={
          machineryTypesList &&
          machineryTypesList.reduce((obj, item) => {
            obj[item.type_id] =
              item[
                `machinery_type_name_${i18n.language}` as keyof Omit<
                  MachineryTypeDto,
                  'type_id'
                >
              ];
            return obj;
          }, {} as { [id: number]: string })
        }
      />
      <Input
        label="model"
        name="model"
        placeholder={`${t('placeholderList.insertModel')}`}
        InputLabelProps={{ shrink: true }}
      />
      <Input
        label="number"
        name="number"
        placeholder={`${t('placeholderList.insertNumber')}`}
        InputLabelProps={{ shrink: true }}
      />
      <Input
        type="number"
        label="plannedFuelConsumption"
        name="road_fuel_consumption"
        placeholder={`${t('placeholderList.insertplannedFuelConsumption')}`}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          inputProps: { step: 0.1 },
        }}
      />
      <Field name="unit_id">
        {({
          field,
          form,
        }: {
          field: FieldProps['field'];
          form: FormikProps<IMachineryForm>;
        }) => (
          <SelectSearch
            name="unit_id"
            placeholder={t('connectedUnit') as string}
            selectOptions={getUnitsSelectOptions(allUnits)}
            value={field.value ?? ''}
            onChange={(e: SelectChangeEvent<unknown>) => {
              const selectedId = e.target.value;
              if (selectedId) {
                form.setFieldValue('unit_id', selectedId);
              }
            }}
            defaultValue={-1}
            defaultMenuItems={{
              value: 'None',
              label: 'placeholderList.selectMachinery',
            }}
          />
        )}
      </Field>
    </>
  );
};
